import React from 'react';

export const EqCommentsModal = {
  title: 'Comments',
  body: (
    <div>
      <p>Description of the earthquake including damage, deaths, and comments on the accuracy of the report.</p>
      <p>
        For example, if the user is interested in earthquakes that include descriptions of effects to schools, enter the word
        {' '}
        <strong>school</strong>
        {' '}
        in the comments field.
      </p>
    </div>
  ),
};
